/**
 * 휴대폰(본인) 인증 
 */
	
	
jQuery(function($){
	
	var exposCnfBtn = $('#cnfBtn');
	 
	$('#smsNo').on('input', function(){
		if( this.value.length < 1 ){
			exposCnfBtn.attr("disabled", true);
		} else if( this.value.length >= 1 ) {
			exposCnfBtn.attr("disabled", false);
		}
	});
	
	$('#smsNo').closest('.gui-input').on('focusin',function(e) {
		// 인증번호에 input 들어가면 error 메시지 없애줌
	    if( $('#certNo').children('span').hasClass('error') ) {
	        $('#certNo').next('.vaild-text').html('');
			$('#certNo').children('span').removeClass('error');
			$('#certNo').parent().removeClass('error');
		}
	});
	
	var CelphnCert = {
			
		timerId : null,
		timerOver : '',
		
		reqOccupCert : function(obj) {
			if( "Y" === $("#reqIng").val() ) {
				CelphnCert.errMsg('err','smsIng');
				return;
			}
			
			CelphnCert.errMsg('clear', 'name');
			CelphnCert.errMsg('clear', 'reqCertNo');
			$('#certNo').attr('style', 'display:none');
			$('#cnfBtn').attr("disabled", true);
			
			var custNm = $('#custNm').val();
			var validCustNm = $('#validCustNm').val();
			var note = $('#note').val();
			var ecp = $('#ecp').val();
			
			if( !Validation.validAll() ){
				return;
			}
			
			//STEP-01. 고객명 검증 
			if( 'true' == validCustNm ) {
				if(!custNm || "undefinded" == custNm) {
					CelphnCert.errMsg('err','emptyNm');
					custNm = '';
					return;
				}
				
				if( !Validation.custNm(this) ) {
					custNm = '';
					return;
				}
			}
			
			var celphnTelno = $("#celphnTelno").val().split("-").join("");
			
			//STEP-02. 휴대폰 번호 검증
			if(!celphnTelno) {
				CelphnCert.errMsg('err','empty');
				return;
			}
			//입력된 전화번호 유효성 검사
			if( !Validation.celphnTelno(this) ) {
				CelphnCert.errMsg('err','celphnErr');
				return;
			}

			var _this = this;
			if( _this.timerId ) {
				clearTimeout(_this.timerId);
			}
			
			//발송이 완료된 후 재발송 가능하도록 설정
			$("#reqIng").val("Y");
			//유효성 검사가 끝난 후 SMS 요청
			var url = "/cust/cert/popup/reqOccupCert.gs";
			var loginId = "";
			if($("#loginFailCert").val() === 'loginPwdFail') {
				loginId = $("#id").val();
			}
			
			/* GRIT-178048 비밀번호 찾기 보안 이슈 긴급 대응 */
			if ($('input[name=mode]').val() === 'pwChg') {
				loginId = $('input[name=loginId]').val()
			}
			
			$.ajax({
				headers: { "cache-control": "no-cache","pragma": "no-cache" },
				type  : "POST",
				cache : false,
				data : {'celphnNo' : celphnTelno, 'custNm' : custNm, 'validCustNm' : validCustNm , 'note' : note, 'ecp' : ecp, 'loginId' : loginId, 'agk': $('#agk').val()},
				url : url,
				success : function(data) {
							$("#reqIng").val("N");//재발송 가능하도록 풀어줌.
							if( data.retCd == 'E'){
								var retMsg = data.retMsg;
								if(retMsg) {
									if( retMsg.indexOf("이름") > -1 ) {
										$('#name').siblings('.vaild-text').html('회원정보가 일치하지 않습니다.');
										$('#name').addClass('error');			
									} else {
										$('#reqCertNo').siblings('.vaild-text').html(data.retMsg);
										$('#reqCertNo').addClass('error');			
									}
								} else {
									$('#reqCertNo').siblings('.vaild-text').html("회원정보가 일치하지 않습니다.");
									$('#reqCertNo').addClass('error');			
								}
							} else if(data.retCd == 'F') {
								$('#reqCertNo').siblings('.vaild-text').html("입력하신 ID의 핸드폰 번호가 일치하지 않습니다.");
								$('#reqCertNo').addClass('error');		
							
							}else {
								$('#reqCertNo').removeClass('error');
								$('#certNo').attr('style', 'display:block');
								$('#reqCertNo').next('.gui-btn').text('다시요청')
								CelphnCert.okMsg('ok','smsOk');
								$("#smsNo").focus();
								//타이머 실행
								CelphnCert.showTimer(180);
								
								// 해킹 유출 점유인증 관련 수정
								if($("#note").val() == 'MODCERT' || $("#note").val() == 'chkList' || $("#note").val() == "mngCert") {
									$('#custNm').attr("disabled", true);
									$('#celphnTelno').attr("disabled", true);
									$('[data-type=clearValue]').css({visibility:'hidden'});
								}
								
								$('#certNo').val(data.certNo);
								$('#recCert').val(data.ecpTrCertStrin);
								
								if(opener) {
									if($("#lay-container").length>0){
										GsBase.popupResize('#lay-container');
									}else if($("#pop-container").length>0){
										GsBase.popupResize('#pop-container');
									}
								}
							}
						},
				error : function(data) {
							$("#reqIng").val("N");//재발송 가능하도록 풀어줌.
							CelphnCert.errMsg('err','reqSysErr');
						}
			});
			
			return;
		},
		
		cnfOccupCert : function(obj) {
			var _this = this;
			if( _this.timerOver === "Y" ) {
				CelphnCert.errMsg('err','timerOver');
				return;
			}
			
			var celphnTelno = $('#celphnTelno').val().split("-").join("");;
			
			//STEP-01. 휴대폰번호 유효성 체크
			if(!celphnTelno) {
				CelphnCert.errMsg('err','empty');
				return;
			}
			//입력된 전화번호 유효성 검사
			if( !Validation.celphnTelno(this) ) {
				CelphnCert.errMsg('err','celphnErr');
				return;
			}
			
			//STEP-01. 인증번호 유효성 체크
			var smsNo = $('#smsNo').val();
			if(!smsNo) {
				CelphnCert.errMsg('err','smsEmpty');
				return;
			}
			if( !$.isNumeric(smsNo) || smsNo.length !== 6 ) {
				CelphnCert.errMsg('err','smsValid');
				return;
			}

			//유효성 검사가 끝난 후 SMS 요청
			var url = "/cust/cert/popup/occupCertRtn.gs";
			var certNo = $('#certNo').val();
			var recCert = $('#recCert').val();
			var loginId = "";
			
			if($("#loginFailCert").val() === 'loginPwdFail') {
				loginId = $("#id").val();
			}
			
			if($("#note").val() === 'chkList') {
				$("#custInfoFrm input[name=userName]").val($("#custNm").val());
			}
			
			$.ajax({
				headers: { "cache-control": "no-cache","pragma": "no-cache" },
				type  : "POST",
				cache : false,
				data : {'celphnNo' : celphnTelno, 'smsNo' : smsNo, 'certNo' : certNo, 'recCert' : recCert, 'loginId' : loginId, 'note' : $('#note').val(), 'agk': $('#agk').val() },
				url : url,
				success : function(data) {
							if( data.retCd === 'Y'){
								CelphnCert.callBack(data);
							} else {
								if( null != data.retMsg && 'null' != data.retMsg && '' != data.retMsg) {
									if(data.retMsg.indexOf("초과") > -1) { // 2022.12 CSR-33219 ISMS-P 인증심사 대비 모의해킹 취약점 조치
										$('#reqCertNo').siblings('.vaild-text').html(data.retMsg);
										$('#reqCertNo').addClass('error');
										$('#certNo').attr('style', 'display:none');
										$('#cnfBtn').attr("disabled", true);
									}else {
										$('#certNo').next('.vaild-text').html(data.retMsg);
									}
								} else {
									CelphnCert.errMsg('err','smsErr');
								}
								$('#certNo').children('span').addClass('error');
								$('#certNo').parent().addClass('error');
							}
							return;
						},
				error : function(data) {
							CelphnCert.errMsg('err','cnfSysErr');
							return;
						}
			});
			
			return;
		},
		
		errMsg : function(type, gbnCd) {
			
			if( 'clear' === type ) {
				switch( gbnCd ) {
				case "reqCertNo":
					$('#reqCertNo').siblings('.vaild-text').html('');
					$('#reqCertNo').removeClass('error');
					
					if( $('#smsNo').val() ) {
						$('#smsNo').val("");
					}

					$('#certNo').next('.vaild-text').html('');
					$('#certNo').children('span').removeClass('error');
					$('#certNo').parent().removeClass('error');
					break;
				case "name":
					$('#name').next('.vaild-text').html('');
					$('#name').removeClass('error');
					break;
				default :
					break;
				}
			}

			if( 'err' === type ) {
				switch( gbnCd ) {
				case "empty"://휴대폰번호 미입력
					$('#reqCertNo').siblings('.vaild-text').html('휴대폰번호를 입력해주세요.');
					$('#reqCertNo').addClass('error');		
					break;
				case "emptyNm"://고객명 없음
					$('#name').next('.vaild-text').html('이름을 입력해주세요.');
					$('#name').addClass('error');	
					break;
				case "custNmValid"://고객명 영문/한글 체크
					$('#name').next('.vaild-text').html('한글과 영어만 사용할 수 있습니다.');
					$('#name').addClass('error');	
					break;
				case "custNmLength"://고객명 길이 체크
					$('#name').next('.vaild-text').html('영문 3자/한글 2자 이상, 한영조합 각 1자 이상 입력해주세요.');
					$('#name').addClass('error');	
					break;
				case "celphnErr"://휴대폰번호 입력 오류
					$('#reqCertNo').siblings('.vaild-text').html('휴대폰번호가 정확하지 않습니다.');
					$('#reqCertNo').addClass('error');
					break;
				case "smsIng"://SMS 요청 중
					$('#reqCertNo').siblings('.vaild-text').html('인증번호 요청 처리중입니다.');
					$('#reqCertNo').addClass('error');
					break;
				case "custNmErr"://고객명 입력 오류
					$('#name').next('.vaild-text').html('이름이 정확하지 않습니다.');
					$('#name').addClass('error');	
					break;
				case "timerOver"://제한 시간 초과
					if( $('#certNo').children('span').hasClass('ok') ) {
						$('#certNo').children('span').removeClass('ok');
						$('#certNo').parent().removeClass('ok');
					}
					$('#certNo').next('.vaild-text').html('제한시간 초과! 인증을 \'다시요청\' 해주세요.');
					$('#certNo').children('span').addClass('error');
					$('#certNo').parent().addClass('error');
					break;
				case "smsEmpty"://SMS 번호 미입력
					if( $('#certNo').children('span').hasClass('ok') ) {
						$('#certNo').children('span').removeClass('ok');
						$('#certNo').parent().removeClass('ok');
					}
					$('#certNo').next('.vaild-text').html('인증번호를 입력하세요.');
					$('#certNo').children('span').addClass('error');
					$('#certNo').parent().addClass('error');
					break;
				case "smsValid"://SMS 번호 유효성 오류
					if( $('#certNo').children('span').hasClass('ok') ) {
						$('#certNo').children('span').removeClass('ok');
						$('#certNo').parent().removeClass('ok');
					}
					$('#certNo').next('.vaild-text').html("인증번호를 정확하게 입력해주세요.");
					$('#certNo').children('span').addClass('error');
					$('#certNo').parent().addClass('error');
					break;
				case "smsErr"://SMS 번호 오류
					if( $('#certNo').children('span').hasClass('ok') ) {
						$('#certNo').children('span').removeClass('ok');
						$('#certNo').parent().removeClass('ok');
					}
					$('#certNo').next('.vaild-text').html("인증번호가 일치하지 않습니다.");
					$('#certNo').children('span').addClass('error');
					$('#certNo').parent().addClass('error');
					break;
				case "reqSysErr"://인증번호요청 시스템 오류
					$('#reqCertNo').siblings('.vaild-text').html('서비스가 원활하지 않습니다.<br>잠시 후 다시 시도해 주세요.');
					$('#reqCertNo').addClass('error');	
					break;
				case "cnfSysErr"://인증번호확인 시스템 오류
					if( $('#certNo').children('span').hasClass('ok') ) {
						$('#certNo').children('span').removeClass('ok');
						$('#certNo').parent().removeClass('ok');
					}
					$('#certNo').next('.vaild-text').html('서비스가 원활하지 않습니다.<br>잠시 후 다시 시도해 주세요.');
					$('#certNo').children('span').addClass('error');
					$('#certNo').parent().addClass('error');
					break;
				default :
					break;
				}
			}
		},
		
		okMsg : function(type, gbnCd) {
			if( 'ok' === type ) {
				switch( gbnCd ) {
				case "smsOk"://휴대폰번호 미입력
					if( $('#certNo').children('span').hasClass('error') ) {
						$('#certNo').children('span').removeClass('error');
						$('#certNo').parent().removeClass('error');
					}
					$('#certNo').next('.vaild-text').html("인증번호가 문자메시지로 발송되었습니다.");
					$('#certNo').children('span').addClass('ok');
					$('#certNo').parent().addClass('ok');
					break;
				default :
					break;
				}
			}
		},
		
		showTimer : function(expirTime) {
			var _this = this;
			
			var reman = expirTime - 1;
			var day, mod, hour, min, sec, cnt;
			
			if( reman >= -1 ) {
				day = Math.floor(expirTime / (3600 * 24));
				mod = expirTime % (3600 * 24);
				hour = Math.floor(mod / 60);
				mod = mod % 3600;
				min = Math.floor(mod /  60);
				sec = mod % 60;
				if( sec < 10 ) {
					cnt = min + ":0" + sec;
				} else {
					cnt = min + ":" + sec;
				}
				
				$('#remain-times').text(cnt);
				
				if( reman < 0 ) {
					_this.timerOver = "Y";
					if( _this.timerId ) {
						clearTimeout(_this.timerId);
					}
					
					CelphnCert.errMsg('err','timerOver');
					$('#cnfBtn').prop("disabled", true);
				} else {
					_this.timerOver = "N";
					_this.timerId = setTimeout(function() {
						_this.showTimer(reman);
					}, 1000);
				}
			}
		},
		
		callBack : function(data) {
			if(opener){
				try{
					opener.occupCertCallBack(data);
				}catch(e){  
					occupCertCallBack(data);
				}
			} else {
				occupCertCallBack(data);
			}

			return;
		},
		
		clearAll : function() {
			$("#celphnTelno").val("");
			$('#reqCertNo').next('.gui-btn').text('인증요청')
			$('#certNo').attr('style', 'display:none');
			$('#cnfBtn').attr('disabled', true);
			CelphnCert.errMsg('clear','reqCertNo');
			return;
		},
		clearCertNo : function() {
			$('#reqCertNo').next('.gui-btn').text('인증요청')
			$('#certNo').attr('style', 'display:none');
			$('#cnfBtn').attr('disabled', true);
			CelphnCert.errMsg('clear','reqCertNo');
			return;
		},
		removeErr : function(obj) {
			var _this = this;
			if( _this.timerOver === "Y" ) {
				return;
			} else {
				$(obj).parent().removeClass("error");
			}
		}
	};
	
	var Validation = {
		celphnTelno : function(obj) {
			var celphnTelno = $("#celphnTelno").val().split("-").join("");

			if( "" === celphnTelno ) {
				CelphnCert.errMsg('err','empty');
				return false;
			}
			//010 번호이면서 자릿수가 맞는지 체크
			if( $("#celphnTelno").val().indexOf('010')===0 && celphnTelno.length === 10 ) {
				CelphnCert.errMsg('err','celphnErr');
				return false;
			}
			//숫자인지, 자릿수가 맞는지 체크
			if( !$.isNumeric(celphnTelno) || celphnTelno.length < 10 || celphnTelno.length > 11 ) {
				CelphnCert.errMsg('err','celphnErr');
				return false;
			}
			//통신사 번호가 맞는지 체크
			var celphnRegExp = /^01(0|1|[6-9])?([0-9]{3,4})?([0-9]{4})$/;
			if( !celphnRegExp.test(celphnTelno) ) {
				CelphnCert.errMsg('err','celphnErr');
				return false;
			}
			
			return true;
		},
		
		custNm : function(obj) {
			var custNm = $('#custNm').val().split(" ").join("");
			if( "" == custNm || "undefinded" == custNm ) {
				CelphnCert.errMsg('err','emptyNm');
				return false;
			}
			
			if( !/^[a-zA-Z가-힣]+$/.test(custNm) ) {
				CelphnCert.errMsg('err','custNmValid');
				return false;
			}
			
			if( !/^([가-힣]+[a-z]+)+[가-힣a-z]*$|([a-z]+[가-힣]+)+[가-힣a-z]*$|^([a-z]{3,})$|^([가-힣]{2,})$/ig.test(custNm) ) {
				CelphnCert.errMsg('err','custNmLength');
				return false;
			}
			
			return true;
		},
		
		smsNo : function(obj) {
			var smsNo = $('#smsNo').val();
			var isOver = CelphnCert.timerOver;
			if( "Y" == isOver ) {
				CelphnCert.errMsg('err','timerOver');
				return false;
			}
			if(!smsNo) {
				CelphnCert.errMsg('err','smsEmpty');
				return false;
			}
			if( !$.isNumeric(smsNo) || smsNo.length !== 6 ) {
				CelphnCert.errMsg('err','smsValid');
				return false;
			}
			return true;
		},
	
		validAll : function(obj) {
			var isValid = true;
			var isCustNm = true;
			//STEP-01. 고객명 검증
			if( 'true' == $('#validCustNm').val() ) {
				isCustNm = Validation.custNm();
			}
			
			var isCelphnTelno = Validation.celphnTelno();
			
			isValid = (isCustNm && isCelphnTelno)
			return isValid;
		}
	};
	
	window.CelphnCert = CelphnCert;
	window.Validation = Validation;
});